export const ignoredMessages = ['Script error.'];
export const partialMessage = [
    'Minified React error #418',
    'Minified React error #423',
    'Minified React error #425',
];
